import { css } from '@emotion/core';
import React, { useEffect, useState } from 'react';

import Container from '@/src/shared/components/Container';
import Section from '@/src/shared/components/Section';
import { bp } from '@/styles';
import request from '@/utils/axios';

import CommitteeMeetings from './CommitteeMeetings';
import CommitteePublications from './CommitteePublications';
import YourCommittees from './YourCommittees';

const styles = {
  container: css`
    display: flex;
    width: 100%;
    flex-direction: column-reverse;
    @media ${bp.xl} {
      flex-direction: row;
    }
  `,
  leftContainer: css`
    width: 100%;
    @media ${bp.xl} {
      width: 60%;
      padding-right: 34px;
    }
  `,
};

const MemberCommittees = ({ personId }) => {
  const [joinedCommittees, setYourCommittees] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await request({
          url: 'profile/profilecommittees',
          params: { personId },
        });
        if (data.Success !== 'false' && Array.isArray(data.Committees)) {
          setYourCommittees(data.Committees);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [personId]);

  if (!joinedCommittees.length) return null;

  return (
    <Section bgColor="gray">
      <Container>
        <section css={styles.container}>
          <section css={styles.leftContainer}>
            <YourCommittees committees={joinedCommittees} />
            <CommitteePublications committees={joinedCommittees} />
          </section>
          <CommitteeMeetings committees={joinedCommittees} />
          <YourCommittees committees={joinedCommittees} column />
        </section>
      </Container>
    </Section>
  );
};

export default MemberCommittees;
